var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChooseGroupArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.895,
    height: 6.406,
    viewBox: "0 0 12.895 6.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4956",
    "data-name": "Path 4956",
    d: "M5.468,0,2.574,3.2l2.895,3.2H2.894L0,3.2,2.894,0Z",
    transform: "translate(7.426 0)",
    fill: "#24b8c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4957",
    "data-name": "Path 4957",
    d: "M46.021,0,43.127,3.2l2.895,3.2H43.448L40.553,3.2,43.448,0Z",
    transform: "translate(-36.84 0)",
    fill: "#24b8c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4958",
    "data-name": "Path 4958",
    d: "M86.574,0,83.68,3.2l2.895,3.2H84L81.107,3.2,84,0Z",
    transform: "translate(-81.106 0)",
    fill: "#24b8c0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseGroupArrow);
export default __webpack_public_path__ + "static/media/choose-group-arrow.973e785c50eab3e156b91b75178a15fa.svg";
export { ForwardRef as ReactComponent };